import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "cinema__record"
};
const _hoisted_2 = {
  class: "record-list"
};
import { ref } from 'vue';
import CinemaRecentPlayItem from '@remote/components/cinema/CinemaRecentPlayItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaRecentPlay',
  props: {
    title: {
      type: String,
      default: '最近观看'
    },
    list: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const containerNodeRef = ref(null);
    const containerInnerNodeRef = ref(null);
    const onWheel = e => {
      e.preventDefault();
      if (containerNodeRef.value) {
        containerNodeRef.value.scrollLeft += e.deltaY;
      }
    };
    return (_ctx, _cache) => {
      var _props$list;
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", null, _toDisplayString(props.title), 1), _createElementVNode("div", {
        class: "record-container hide-scrollbar disable-overscroll",
        ref_key: "containerNodeRef",
        ref: containerNodeRef,
        onWheel: onWheel
      }, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, record => {
        var _record$scrape_result;
        return _openBlock(), _createBlock(CinemaRecentPlayItem, {
          nfo: record,
          key: (_record$scrape_result = record.scrape_result) === null || _record$scrape_result === void 0 ? void 0 : _record$scrape_result.id
        }, null, 8, ["nfo"]);
      }), 128))])], 544)], 512)), [[_vShow, ((_props$list = props.list) === null || _props$list === void 0 ? void 0 : _props$list.length) > 0]]);
    };
  }
});